import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";

import InputAdornment from "@mui/material/InputAdornment";
import Skeleton from "@mui/material/Skeleton";
export default function NumberStepper({
	initValue,
	min,
	max,
	step,
	typeUnite = "piece", // "piece" ou "Kg"
	onChange,
}) {
	const [value, setValue] = useState(undefined);
	const [input, setInput] = useState("");
	const [error, setError] = useState(false);
	const [helperText, setHelperText] = useState("");

	const clamp = (val) => Math.max(min, Math.min(max, val));

	const formatValue = (val) => {
		if (typeUnite === "Kg") return parseFloat(val).toFixed(3);
		return Math.round(val).toString();
	};
	/*
	const parseValue = (val) => {
		if (typeUnite === "Kg") return parseFloat(parseFloat(val).toFixed(3));
		return parseInt(val, 10);
	};*/

	const roundKg = (val) => parseFloat(val.toFixed(3));

	const isValidInput = (val) => {
		const regex = typeUnite === "Kg" ? /^\d+([.,]\d{0,3})?$/ : /^\d+$/;
		return regex.test(val);
	};

	const handleChange = (newVal) => {
		const clamped = clamp(newVal);
		setValue(clamped);
		setInput(formatValue(clamped));
		setError(false);
		setHelperText("");
		if (onChange) onChange(clamped);
	};

	const handleInputChange = (e) => {
		const val = e.target.value.replace(",", "."); // support FR
		setInput(val);

		if (!isValidInput(val)) {
			setError(true);
			setHelperText("Entrée invalide");
			return;
		}

		const parsed = parseFloat(val);
		if (isNaN(parsed)) {
			setError(true);
			setHelperText("Valeur non valide");
			return;
		}

		if (parsed < min || parsed > max) {
			setError(true);
			setHelperText(`Entre ${min} et ${max}`);
			return;
		}

		setError(false);
		setHelperText("");
		handleChange(typeUnite === "Kg" ? roundKg(parsed) : parsed);
	};

	const handleBlur = () => {
		// Si vide ou invalide, revenir à la dernière valeur correcte
		if (error || input === "") {
			setInput(formatValue(value));
			setError(false);
			setHelperText("");
		}
	};

	const handleIncrement = () => {
		const newVal =
			typeUnite === "Kg"
				? roundKg(parseFloat(value) + step)
				: parseFloat(value) + step;
		handleChange(newVal);
	};

	const handleDecrement = () => {
		const newVal =
			typeUnite === "Kg"
				? roundKg(parseFloat(value) - step)
				: parseFloat(value) - step;
		handleChange(newVal);
	};
	useEffect(() => {
		const formatValueEffect = (val) => {
			if (typeUnite === "Kg") return parseFloat(val).toFixed(3);
			return Math.round(val).toString();
		};

		if (initValue !== undefined) {
			setValue(initValue);
			setInput(formatValueEffect(initValue));
		}
	}, [initValue, typeUnite]);

	if (value === undefined) return <Skeleton variant="rounded" />;

	return (
		<Box
			display="flex"
			alignItems="center"
			gap={1}
		>
			<IconButton
				onClick={handleDecrement}
				disabled={value <= min}
			>
				<RemoveIcon />
			</IconButton>
			<TextField
				type="text"
				value={input}
				onChange={handleInputChange}
				onBlur={handleBlur}
				error={error}
				helperText={helperText}
				inputProps={{
					inputMode: "decimal",
					style: { textAlign: "center" },
				}}
				InputProps={{
					endAdornment: (
						<InputAdornment position="end">
							{typeUnite === "Kg" ? "kg" : "pièce(s)"}
						</InputAdornment>
					),
				}}
				size="small"
				sx={{ width: 140 }}
			/>
			<IconButton
				onClick={handleIncrement}
				disabled={value >= max}
			>
				<AddIcon />
			</IconButton>
		</Box>
	);
}
